import React from "react";
import AdminButton from "./adminButton";

// confirmação inline ("Tem certeza?") que aparece no lugar do botão de ação
export default function AdminConfirm({
    message = "Tem certeza?",
    confirmLabel = "Sim",
    cancelLabel = "Não",
    onConfirm,
    onCancel,
    danger = false,
    loading = false,
    className = ""
}: {
    message?: React.ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onCancel: () => void;
    danger?: boolean;
    loading?: boolean;
    className?: string;
}) {
    return (
        <div className={`flex flex-wrap items-center justify-end gap-2 rounded-lg bg-gray-50 ring-1 ring-gray-200 px-3 py-2 ${className}`}>
            <span className="text-sm font-semibold text-gray-700 mr-auto">{message}</span>
            <div className="flex gap-2">
                <AdminButton size="sm" variant="secondary" disabled={loading} onClick={onCancel}>{cancelLabel}</AdminButton>
                <AdminButton size="sm" variant={danger ? "danger" : "primary"} loading={loading} onClick={onConfirm}>{confirmLabel}</AdminButton>
            </div>
        </div>
    )
}
